import {PageService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

export default {
  data(){
    return {
      content: [],
      loading: true,
    }
  },
  methods: {
    getContent() {
      this.loading = true;
      if(this.$breakpoints.xs || this.$breakpoints.sm) {
        Vue.nextTick(() => {
          if(this.$parent.$el != undefined) window.scroll({top: (this.$parent.$el.offsetTop - 100), left: 0, behavior: 'smooth'})
        })
      }
      PageService.getGeneralPage("History",null).then((response)=> {
        this.content = response[0].History.History;
        this.loading = false;
      })
    }
  },
  created(){
    this.getContent()
  },
  watch: {
    '$route' () {
      this.getContent()
    }
  },

  beforeMounted() {
    this.getContent()
  }
}


// WEBPACK FOOTER //
// ./src/components/about/our-history/our-history.js